<template>
  <div class="c-featured-products-two-columns">
    <div class="l-container">
      <div :class="contentClass">
        <div v-if="!textOverAccordion">
          <h2
            v-if="title"
            class="c-featured-products-two-columns-title u-margin-bottom-x-small"
            :class="titleTypography"
          >
            {{ title }}
          </h2>
          <h3
            v-if="subtitle"
            class="c-featured-products-two-columns-subtitle u-margin-bottom-medium"
            :class="subtitleTypography"
          >
            {{ subtitle }}
          </h3>
          <wysiwyg
            v-if="description"
            :html="description"
            paragraph-size="large"
            class="u-margin-bottom-medium"
          />
        </div>
      </div>
      <div class="l-grid l-grid--2-col l-grid--mobile-tab-port">
        <div
          v-if="image && image.src"
          :class="`c-featured-products-two-columns__image${isMobile?'-mobile':''}`"
          :style="{
            background: 'url(' + image.src + ') no-repeat center',
          }"
        />
        <div
          :class="gridItemClass"
          class="u-center-text"
        >
          <div
            v-if="textOverAccordion"
            class="u-text-align-left"
          >
            <h2
              v-if="title"
              class="c-featured-products-two-columns-title u-margin-bottom-x-small"
              :class="titleTypography"
            >
              {{ title }}
            </h2>
            <h3
              v-if="subtitle"
              class="c-featured-products-two-columns-subtitle u-margin-bottom-medium"
              :class="subtitleTypography"
            >
              {{ subtitle }}
            </h3>
            <wysiwyg
              v-if="description"
              :html="description"
              paragraph-size="large"
              class="u-margin-bottom-medium"
            />
          </div>
          <product-carousel
            v-if="products"
            :products="products"
            :force-mobile="true"
            :class="carouselClass"
          />
          <div
            v-if="column"
            :class="gridColumns"
            class="c-featured-products-two-columns__column"
          >
            <template v-for="col in column">
              <column
                :key="col.id"
                :column="col.data"
                :number-of-columns="column.length"
                v-bind="col.data"
              />
            </template>
          </div>
          <btn
            v-if="cta"
            v-bind="cta"
          >
            {{ cta.text }}
          </btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/button/Btn";
import ProductCarousel from "@/components/carousel/ProductCarousel";
import Wysiwyg from "../wysiwyg/Wysiwyg";
import isMobile from '@mixins/isMobile';
import Column from '../layout/Column.vue'

/**
   * wrap the stateless HomepageFeaturedRings component in a stateful context
   */
export default {
  components: {
    Btn,
    ProductCarousel,
    Wysiwyg,
    Column,
  },
  mixins: [
    isMobile
  ],
  props: {
    products: {
      type: Array,
      default: () => []
    },
    textAlignment: {
      type: String,
      default: ""
    },
    textFullWidth: {
      type: Boolean,
      default: false
    },
    textOverAccordion: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    titleTypography: {
      type: String,
      default: 't-heading-3'
    },
    subtitle: {
      type: String,
      default: ""
    },
    subtitleTypography: {
      type: String,
      default: 't-heading-3'
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => ({})
    },
    mobileImage: {
      type: Object,
      default: () => ({})
    },
    imageSide: {
      type: String,
      default: "left"
    },
    column: {
      type: Array,
      default: null
    },
    cta: {
      type: Object,
      default: null
    }
  },
  computed: {
    contentClass() {
      let results = 'c-featured-products-two-columns__content';
      if (this.textFullWidth == true) {
        results += ' c-featured-products-two-columns__content--full-width'
      }
      if (this.textAlignment == 'center') {
        results += ' u-margin-auto u-text-align-center'
      }
      return results;
    },
    gridItemClass() {
      if(this.imageSide == 'right') {
        return 'l-grid__item l-grid__item--first-until-tab-port'
      } else {
        return 'l-grid__item'
      }
    },
    carouselClass() {
      if (this.cta) {
        return 'u-margin-bottom-x-large';
      } else {
        return '';
      }
    },
    gridColumns() {
      let numberOfColumns = this.column.length;
      var modifier = '';
      if (numberOfColumns > 1) {
        modifier = ' l-grid--' + numberOfColumns + '-col';
      }
      modifier += ' l-grid--align-' + this.textAlignment;
      return 'l-grid' + modifier;
    },
  },
}
</script>

<style lang="scss" scoped>
  .c-featured-products-two-columns {
    padding: $section-padding;
    &-title {
      margin-top: 30px;
    }
    &-subtitle {
      margin: 30px 0px;
    }

    &__content {
      max-width: rem(614px);
      @include respond(tab-port) {
        margin: auto;
        text-align: center;
      }
    }

    &__content--full-width {
      max-width: 100%;
    }

    &__image {
      width: 100%;
      height: 0;
      padding-top: 100%;
      background-size: cover;
      &-mobile {
        width: 100%;
        height: 0;
        padding-top: 100%;
        background-size: 100% auto;
      }
    }

    &__column {
      align-items: end;
    }
  }
</style>
